import React, { useState } from 'react';
import { ArrowLeft, Map } from 'lucide-react';
import { ZoneCard } from '../components/ZoneCard';
import { InventoryCard } from '../components/InventoryCard';
import { useInventory, Zone } from '../hooks/useInventory';
interface StorageZonesProps {
  onBack: () => void;
  onItemClick: (item: any) => void;
}
export function StorageZones({
  onBack,
  onItemClick
}: StorageZonesProps) {
  const {
    getByZone
  } = useInventory();
  const [selectedZone, setSelectedZone] = useState<Zone | null>(null);
  const zones: Zone[] = ['Kitchen Pantry', 'Refrigerator', 'Freezer', 'Bathroom', 'Cleaning Closet'];
  if (selectedZone) {
    const zoneItems = getByZone(selectedZone);
    return <div className="pb-24 max-w-md mx-auto p-4 min-h-screen" data-id="element-517">
        <div className="flex items-center mb-6" data-id="element-518">
          <button onClick={() => setSelectedZone(null)} className="mr-3 p-2 hover:bg-[#C9A227]/20 rounded-full transition-colors" data-id="element-519">
            <ArrowLeft className="w-5 h-5 text-[#722F37]" data-id="element-520" />
          </button>
          <div data-id="element-521">
            <h1 className="text-xl font-cinzel font-bold text-[#2C2C2C]" data-id="element-522">
              {selectedZone}
            </h1>
            <p className="text-sm text-[#722F37] font-serif italic" data-id="element-523">
              {zoneItems.length} items revealed
            </p>
          </div>
        </div>

        <div className="space-y-3" data-id="element-524">
          {zoneItems.length === 0 ? <div className="text-center py-16 text-[#2C2C2C]/40" data-id="element-525">
              <p className="text-lg font-cinzel mb-2" data-id="element-526">This chamber is empty</p>
              <p className="text-sm font-serif italic" data-id="element-527">
                Conjure items to fill this space
              </p>
            </div> : zoneItems.map(item => <InventoryCard key={item.id} item={item} onClick={() => onItemClick(item)} data-id="element-528" />)}
        </div>
      </div>;
  }
  return <div className="pb-24 max-w-md mx-auto p-4 min-h-screen" data-id="element-529">
      <div className="flex items-center gap-3 mb-2" data-id="element-530">
        <div className="p-2 bg-[#F5F0E1] border border-[#C9A227] rounded-lg" data-id="element-531">
          <Map className="w-5 h-5 text-[#722F37]" data-id="element-532" />
        </div>
        <h1 className="text-xl font-cinzel font-bold text-[#2C2C2C]" data-id="element-533">
          Revelio Zones
        </h1>
      </div>
      <p className="text-[#722F37] text-sm mb-6 font-serif italic ml-12" data-id="element-534">
        Tap to reveal contents within
      </p>

      <div className="grid grid-cols-2 gap-4" data-id="element-535">
        {zones.map(zone => {
        const items = getByZone(zone);
        const hasWarning = items.some(i => i.status === 'Warning' || i.status === 'Critical');
        return <ZoneCard key={zone} name={zone} itemCount={items.length} hasWarning={hasWarning} onClick={() => setSelectedZone(zone)} data-id="element-536" />;
      })}
      </div>
    </div>;
}